import theme from "@/styles/theme";
import Grid from "@mui/material/Grid";
import {EventRow} from "./EventRow";
import {NoDataFound} from "./NoDataFound";

export const EventOverview = ({bandProfile, events, editEvents, onChanged, ref}) => {

    if (!events || events.length === 0) {
        return <NoDataFound type="Events"/>;
    }

    return events.map((event) => {
        return (
            <Grid
                container
                justifyContent="center"
                key={event.id}
                sx={{
                    padding: "0.25rem 0",
                    [theme.breakpoints.up("sm")]: {
                        padding: "1rem 0",
                    },
                    "&.MuiGrid-root:not(:last-of-type)": {
                        borderBottomColor: theme.palette.common.black,
                        borderBottomStyle: "solid",
                        borderBottomWidth: "1px",
                    },
                }}
            >
                <Grid item xs={12}>
                    <EventRow
                        editEvents={editEvents}
                        onChanged={onChanged}
                        event={event}
                        bandProfile={bandProfile}
                    />
                </Grid>
            </Grid>
        );
    });
};
